export default "__VITE_ASSET__DlfMfC4I__"